<template>
  <div v-if="user" class="impersonation-banner">
    <div class="banner-content">
      <div class="info">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5 text-white"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        <span class="message">
          คุณกำลังจำลองเป็นผู้ใช้: <strong>{{ user.name }}</strong>
        </span>
      </div>
      <button @click="onStop" class="stop-btn">เลิกจำลอง</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import {
  getImpersonatingUser,
  stopImpersonation,
} from "../../services/service";

const user = ref(null);

onMounted(() => {
  user.value = getImpersonatingUser();
});

const onStop = () => {
  stopImpersonation();
};
</script>

<style scoped>
.impersonation-banner {
  background: linear-gradient(90deg, #eb4648 0%, #d93c3e 100%);
  color: white;
  padding: 8px 16px;
  position: sticky;
  top: 0;
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.banner-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info {
  display: flex;
  items-center: center;
  gap: 12px;
}

.message {
  font-size: 14px;
}

.stop-btn {
  background: white;
  color: #eb4648;
  border: none;
  padding: 4px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.stop-btn:hover {
  background: #fefefe;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.stop-btn:active {
  transform: translateY(0);
}
</style>
